<template>
  <div>
    <AlertsComponent context="payment" />
    <v-main class="pt-0">
      <!-- Disclaimer for Credit Card / Debit Card Kubra before launching a new tab-->
      <v-dialog
        v-model="dialog"
        :persistent="persistent"
        :fullscreen="$vuetify.display.xs"
        :max-width="$vuetify.display.xs ? '100vw' : '880px'"
        :min-width="$vuetify.display.xs ? '100vw' : '700px'"
        :min-height="$vuetify.display.xs ? '92vh' : '100%'"
        z-index="10000"
      >
        <v-card class="orangeTop">
          <v-card-title class="text-center font-size--20 font-weight-bold mt-4">
            <span class="centerText my-4">{{ $t('L_You_are_about_to_leave_MyPrimerica') }}</span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <span class="font-size--16 font-weight-bold">{{
                  $t('L_You_will_need_the_following_information_to_make_your_payment')
                }}</span>
              </v-col>
              <v-col cols="12" class="mt-4">
                <v-row class="font-weight-regular">
                  <v-col cols="12" sm="2" class="mb-4">
                    <span class="font-size--12" v-if="isCanadaPolicy">{{
                      $t('L_Postal_Code')
                    }}</span>
                    <span class="font-size--12" v-else>{{ $t('L_Zip_Code') }}</span>
                    <div cols="2" class="font-size--18 font-weight-bold">
                      {{ zipCode }}
                    </div>
                  </v-col>
                  <v-col cols="12" sm="10" class="mb-4">
                    <span class="font-size--12">{{ $t('L_Policy_Number') }}</span>
                    <div
                      cols="10"
                      class="font-size--18 font-weight-bold"
                      @click="copyPolicyToClipboard()"
                    >
                      {{ contractId }}
                      <span class="clickable font-size--16 font-weight-bold blue_label">
                        <v-icon color="primary" :icon="mdiContentCopy" /> {{ $t('L_copy') }}
                      </span>
                    </div>
                    <br />
                    <span>{{ $t('L_enter_in_account_number_field_when_prompted') }}</span>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" class="my-4">
                <span class="font-size--16 font-weight-bold mt-4">{{
                  $t('L_Important_information_regarding_your_account')
                }}</span>
              </v-col>
              <v-col cols="12" class="mx-4">
                <ul>
                  <li class="spaceBelow10">
                    {{ $t('L_Payments_will_show_on_your_statement_as_Primerica_EZ') }}
                  </li>
                  <li class="spaceBelow10">
                    {{ $t('L_all_payments_made_through_this_website_are_processed') }}
                  </li>
                  <li class="spaceBelow10">
                    {{
                      $t(
                        'L_Payments_made_before_4PM_ET_typically_will_be_posted_the_following_business_day'
                      )
                    }}
                  </li>
                  <li class="spaceBelow10">
                    {{
                      $t(
                        'L_Payments_made_after_4PM_ET_typically_will_be_posted_no_later_than_2_business_days_after_payment'
                      )
                    }}
                  </li>
                  <li class="spaceBelow10">
                    {{
                      $t(
                        'L_Payments_made_on_or_after_the_premium_due_date_will_not_prevent_the_Life_Insurance_policy_from_lapsing'
                      )
                    }}
                  </li>
                  <li class="spaceBelow10">
                    {{
                      $t(
                        'L_By_Clicking_Continue_below_you_consent_to_Primerica_sharing_your_account_information'
                      )
                    }}
                  </li>
                </ul>
              </v-col>
              <v-col cols="12" class="my-4">
                <div class="font-size--14 font-weight-bold">
                  {{ $t('L_Third_Party_Website_Disclaimer') }}
                </div>
                <div class="font-size--12 font-weight-regular">
                  {{
                    $t(
                      'L_By_clicking_I_Agree_you_will_enter_a_website_operated_by_an_entity_not_affiliated_with_Primerica'
                    )
                  }}
                </div>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pb-4 mb-4">
            <v-row justify="center" class="pb-4 mb-4">
              <v-col cols="12" sm="12" md="12" class="d-flex justify-center maxwidthButton px-2">
                <OnexButton block variant="outlined" color="outlined" @click="dialog = false">
                  {{ $t('L_cancel') }}
                </OnexButton>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
                class="pb-4 d-flex justify-center maxwidthButton px-2"
              >
                <OnexButton block base-color="primary" color="primary" @click="goToNextStep()">
                  {{ $t('L_I_agree') }}
                </OnexButton>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- info/tooltip - Check image showing routing and account number-->
      <v-dialog v-model="showcheck" max-width="880" :persistent="persistent">
        <v-card class="orangeTop">
          <v-card-title class="mb-4 d-flex flex-wrap justify-center align-start">
            <div class="w-100 text-right">
              <v-icon :icon="mdiClose" size="large" @click="showcheck = false" />
            </div>
            <h1 class="text-center w-100">
              {{ $t('L_how_to_find_the_routing_and_account_number') }}
            </h1>
          </v-card-title>
          <div class="d-flex justify-center">
            <v-img v-if="locale === 'en_US'" src="./check-mobile.svg" alt="check" max-width="95%" />
            <v-img
              v-else-if="locale === 'en_CA'"
              src="./CanadaCheckEn.png"
              alt="check"
              max-width="95%"
            />
            <v-img
              v-else-if="locale === 'fr_CA'"
              src="./CanadaCheckFr.png"
              alt="check"
              max-width="95%"
            />
          </div>
          <div v-if="locale === 'en_US'" class="d-flex flex-wrap justify-center">
            <div class="text-center text-1 font-weight-bold w-50">|</div>
            <div class="text-center text-1 font-weight-bold w-50">|</div>
            <div class="text-center w-50">
              {{ $t('L_routing_number') }}
            </div>
            <div class="text-center w-50">
              {{ $t('L_account_number') }}
            </div>
          </div>
          <div v-else class="d-flex justify-center px-6">
            <div class="text-center legend-text" :class="$vuetify.display.xs ? '' : 'pl-16'">
              {{ $t('L_routing_number') }}
            </div>
            <div class="text-center legend-text">
              {{ $t('L_institution_number') }}
            </div>
            <div class="text-center legend-text" :class="$vuetify.display.xs ? '' : 'pr-16'">
              {{ $t('L_account_number') }}
            </div>
          </div>

          <v-row class="mt-4 mb-4 align-center justify-center">
            <v-col cols="12" class="maxwidthButton2">
              <OnexButton color="primary" block @click="showcheck = false">
                {{ $t('L_OK') }}
              </OnexButton>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>
      <div cols="12" v-if="selectedAmountOverLimit">
        <!-- Amount 2500 or higher -->
        <OnexAlert :type="Notifications.info">
          {{ $t('L_credit_and_debit_card_payment_option_is_not_available') }}
        </OnexAlert>
      </div>
      <div>
        <!-- Payment Method Selections / Options -->
        <div class="px-6 pt-8">
          <v-row>
            <v-col cols="12">
              <v-row class="mr-0">
                <v-col cols="12">
                  <h4>
                    {{ $t('L_please_select_your_payment_method') }}
                  </h4>
                </v-col>
                <v-col cols="12" sm="4" class="clickable mb-2 pr-0">
                  <div
                    class="text-left d-flex align-center"
                    :class="paymentMethod === 0 ? 'green-border-box' : 'gray-border-box'"
                    @click="setPaymentMethod(0)"
                  >
                    <v-icon
                      :color="paymentMethod === 0 ? '#39ac4b' : '#02579e'"
                      class="mx-1"
                      :icon="mdiBank"
                    />
                    <span
                      class="font-weight-semibold"
                      :class="{ 'font-size--14': $vuetify.display.sm }"
                    >
                      {{ $t('L_checking') }}
                    </span>
                    <v-spacer></v-spacer>
                    <v-icon
                      color="#39ac4b"
                      v-if="paymentMethod === 0"
                      class="greenCheckRight"
                      :icon="mdiCheckCircle"
                    />
                  </div>
                </v-col>
                <v-col cols="12" sm="4" class="clickable mb-2 pr-0">
                  <div
                    class="text-left d-flex align-center"
                    :class="paymentMethod === 1 ? 'green-border-box' : 'gray-border-box'"
                    @click="setPaymentMethod(1)"
                  >
                    <v-icon
                      :color="paymentMethod === 1 ? '#39ac4b' : '#02579e'"
                      class="mx-1"
                      :icon="mdiPiggyBank"
                    />
                    <span
                      class="font-weight-semibold"
                      :class="{ 'font-size--14': $vuetify.display.sm }"
                    >
                      {{ $t('L_savings') }}
                    </span>
                    <v-spacer></v-spacer>
                    <v-icon
                      color="#39ac4b"
                      v-if="paymentMethod === 1"
                      class="greenCheckRight"
                      :icon="mdiCheckCircle"
                    />
                  </div>
                </v-col>
                <v-col cols="12" sm="4" v-if="!isNyPolicy" class="clickable mb-2 pr-0">
                  <div
                    class="text-left d-flex align-center"
                    :class="{
                      'green-border-box': paymentMethod === 2,
                      'gray-border-box': paymentMethod !== 2,
                      'gray-box': selectedAmountOverLimit,
                    }"
                    @click="setPaymentMethod(2)"
                  >
                    <v-icon
                      :color="paymentMethod === 2 ? '#39ac4b' : '#02579e'"
                      class="mx-1"
                      :icon="mdiCreditCardOutline"
                    />
                    <span
                      class="font-weight-semibold"
                      :class="{ 'font-size--14': $vuetify.display.sm }"
                    >
                      {{ $t('L_Credit_or_Debit_Card') }}
                    </span>
                    <v-spacer></v-spacer>
                    <v-icon
                      color="#39ac4b"
                      v-if="paymentMethod === 2"
                      class="greenCheckRight"
                      :icon="mdiCheckCircle"
                      :size="$vuetify.display.sm ? 'small' : '24'"
                    />
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <!-- Checking and Savings -->
          <v-row v-if="paymentMethod === 0 || paymentMethod === 1">
            <v-col cols="12">
              <!-- Please enter your bank account info-->
              <v-row>
                <v-col cols="12">
                  <h4>{{ $t('L_please_enter_your_bank_account_information') }}</h4>
                </v-col>
              </v-row>
              <!-- Routing Account Bank Name-->
              <v-row class="ml-0">
                <v-col cols="12" sm="6" class="d-flex flex-column pl-0">
                  <OnexRoutingNumber
                    v-model="routingNumber"
                    :label="$t('L_routingUS_transitAndInstitutionCAN')"
                    :country="getCountry"
                    required
                  ></OnexRoutingNumber>
                  <OnexText
                    v-model="bankName"
                    :label="$t('L_bank_name')"
                    :rules="[bankNameUpdate]"
                    readonly
                  ></OnexText>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  class="d-flex flex-column"
                  :class="$vuetify.display.xs ? 'pl-0' : 'pl-4'"
                >
                  <OnexAccountNumber
                    v-model="bankAcctNumber"
                    :label="$t('L_account_number')"
                    :country="getCountry"
                    required
                    @copy.prevent
                  ></OnexAccountNumber>
                  <OnexAccountNumber
                    v-model="verifyBankAcctNumber"
                    :label="$t('L_confirm_account_number')"
                    required
                    :country="getCountry"
                    :appendValidations="[accountVerifyingRule]"
                    @paste.prevent
                  ></OnexAccountNumber>
                </v-col>
              </v-row>
              <!-- ? Where to find Bank Routing and Account Number -->
              <v-row text-left>
                <v-col cols="12" @click="showCheckImage">
                  <span>
                    <v-icon class="mr-2" color="#0c6dca" :icon="mdiHelpCircle" />
                  </span>
                  <span class="font-weight-bold font-size--16 blueText mouseCursor">
                    {{ $t('L_Where_to_find_Bank_Routing_and_Account_Number') }}
                  </span>
                </v-col>
                <v-col cols="12" class="mt-4 font-size--16">
                  <div>
                    {{
                      $t(
                        'L_By_continuing_with_this_payment_method_you_agree_that_you_are_the_owner'
                      )
                    }}
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <!-- Credit and Debit -->
          <!-- Blue Box Alert - Make a payment using a credit or debit card -->
          <!-- TODO: consider onex alert instead of custom styled component -->
          <div class="blueBox mt-6" v-else-if="paymentMethod === 2">
            <div class="d-flex" :class="$vuetify.display.xs ? 'align-start' : 'align-center'">
              <v-icon color="blue500" class="mr-2" :icon="mdiInformation" />
              <h4>
                <span>{{ $t('L_make_a_payment_using_a_credit_or_debit_card') }}</span>
              </h4>
            </div>
            <p class="ml-8">
              {{ $t('L_to_complete_this_payment_you_will_be_directed_to_our_vendor_site') }}
            </p>
          </div>

          <!-- Button -->
          <v-row class="d-flex justify-end mt-4 pt-4 mb-4 pb-4">
            <v-col cols="12" sm="4" md="3" class="px-4">
              <OnexButton block variant="outlined" color="outlined" @click="cancel">
                {{ $t('L_cancel') }}
              </OnexButton>
            </v-col>
            <v-col cols="12" sm="4" md="3" class="px-4">
              <OnexButton block :disabled="badForm" @click="goToStepThree">
                {{ $t('L_continue') }}
              </OnexButton>
            </v-col>
          </v-row>
        </div>
      </div>
    </v-main>
  </div>
</template>

<script lang="ts">
import { formatDate } from '@/shared/util/formatters';
import { required, minLength, maxLength, sameAs } from '@vuelidate/validators';
import stringValues from '@/shared/util/stringValues';
import { filters } from '@/mixins/filters';
import { openInNewWindow } from '@/mixins/openNewWindow';
import AlertsComponent from '@/components/AlertsComponent.vue';
import { mapState, mapStores } from 'pinia';
import { useCustomerStore } from '@/stores/customer/customer.store';
import { usePolicyStore } from '@/modules/policy/store/policy.store';
import { useGlobalStore } from '@/stores/global/global.store';
import { addMonths, format } from 'date-fns';
import type { IGetBankDataPayload } from '@/shared/api/models.bff';
import { useVuelidate } from '@vuelidate/core';
import { defineComponent, type ComponentOptions } from 'vue';
import {
  mdiBank,
  mdiCheckCircle,
  mdiClose,
  mdiContentCopy,
  mdiCreditCardOutline,
  mdiHelpCircle,
  mdiInformation,
  mdiPiggyBank,
} from '@mdi/js';
import {
  OnexAccountNumber,
  OnexRoutingNumber,
  OnexText,
  OnexButton,
  OnexBoolean,
  OnexSelect,
  OnexAlert,
  Countries,
  Notifications,
} from '@primerica/onex-ui-lib';

export const notSameDigits = (value: string) => {
  const regexp = /(\d)\1{7}/;
  return !regexp.test(value);
};

export const letterSpaceLetter = (value: string) => {
  const regexp = /^[a-zA-Z]+[\sa-zA-Z-.]{0,}[a-zA-Z]+$/;
  return regexp.test(value);
};

const componentOptions: ComponentOptions = {
  name: 'PayStepTwo',
  components: {
    AlertsComponent,
    OnexAccountNumber,
    OnexRoutingNumber,
    OnexText,
    OnexButton,
    OnexBoolean,
    OnexSelect,
    OnexAlert,
  },
  mixins: [openInNewWindow],
  props: {
    selectedAmount: {
      type: String,
      required: true,
      default: '0',
    },
    policyData: {
      type: Object,
      required: true,
      default: () => {},
    },
    minimumAmountSelected: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data: () => ({
    persistent: true,
    dialog: false,
    accountHolder: '',
    bankAcctNumber: '',
    verifyBankAcctNumber: '',
    routingNumber: '',
    readonly: '',
    accountHolderErrorMessages: [] as string[],
    showcheck: false,
    paymentMethod: -1,
    v$: useVuelidate(),
    mdiBank,
    mdiCheckCircle,
    mdiPiggyBank,
    mdiCreditCardOutline,
    mdiHelpCircle,
    mdiInformation,
    mdiContentCopy,
    mdiClose,
    Notifications,
  }),
  computed: {
    ...mapStores(usePolicyStore),
    ...mapState(useCustomerStore, ['customerProfile']),
    ...mapState(usePolicyStore, [
      'policies',
      'currentPolicy',
      'routeNameToNavigateBack',
      'selectedPolicyIndex',
      'bankNameResponse',
      'paymentData',
      'bankName',
    ]),
    ...mapState(useGlobalStore, {
      locale: 'getLocale',
      dateFormat: 'getDateFormat',
    }),
    accountVerifyingRule() {
      return () =>
        this.verifyBankAcctNumber === this.bankAcctNumber ||
        this.$t('L_verify_bank_account_number_must_be_same');
    },
    bankNameUpdate() {
      if (this.routingNumber === '') this.readonly = '';
      else if (this.routingNumber != '' && this.routingNumber.length === 9) this.readonly = '';
    },
    isCanadaPolicy() {
      return this.currentPolicy?.isCanadaPolicy;
    },
    getCountry() {
      return this.isCanadaPolicy ? Countries.CA : Countries.US;
    },
    selectedAmountOverLimit() {
      return parseInt(this.selectedAmount.replaceAll(',', ''), 10) >= 2500;
    },
    contractId() {
      return this.currentPolicy?.contractId;
    },
    zipCode() {
      return this.currentPolicy?.owner?.address.zip;
    },
    disableAccountHolderNameEdit() {
      return window.appConfig.payments.disableAccountHolderNameEdit;
    },
    bankName() {
      const name = this?.bankNameResponse ? this.bankNameResponse[0]?.name : null;
      return name || '';
    },
    accountOptions() {
      return [
        {
          label: this.$t('L_savings_account'),
          value: this.bankAccountType === 3 ? 0 : 1,
        },
        {
          label: this.$t(this.checkingAccount),
          value: this.bankAccountType === 3 ? 1 : 0,
        },
      ];
    },
    badForm() {
      if (this.paymentMethod === 2) {
        return false;
      }
      return (
        this.paymentMethod === '' ||
        this.bankName === '' ||
        this.v$.$invalid ||
        this.bankAcctNumber.length === 0 ||
        this.verifyBankAcctNumber.length === 0 ||
        this.routingNumber.length === 0
      );
    },
    isNyPolicy() {
      return this?.policyData?.isNewYorkPolicy;
    },
    checkingAccount() {
      return this.isCanadaPolicy ? 'L_chequing_account' : 'L_checking_account';
    },
    bankAccountType() {
      return this.policyData?.paymentInfo?.accountType;
    },
    formattedPaymentType() {
      return this.policyData?.billingMode && this.policyData?.billingForm
        ? stringValues.paymentMethod(this.policyData)
        : '';
    },
    futurePaidToDate() {
      const paidToDate = new Date(this.policyData?.paymentInfo?.paidToDate);
      if (this.minimumAmountSelected) {
        const futurePaidToDate2 = format(addMonths(paidToDate, 1), 'yyyy-MM-dd');
        return formatDate(futurePaidToDate2, this.dateFormat);
      }
      const futurePaidToDate3 = format(
        addMonths(paidToDate, this.policyData?.billingMode),
        'yyyy-MM-dd'
      );
      return formatDate(futurePaidToDate3, this.dateFormat);
    },
    accountDiff() {
      const ca_bankName = this.policyData?.paymentInfo?.bank?.name || '';
      const currentAccount = [
        ca_bankName.trim(),
        this.policyData?.paymentInfo?.routingNumber,
        this.policyData?.paymentInfo?.accountNumber,
      ].toString();
      const paymentData = [
        this.bankName.trim(),
        this.routingNumber,
        this.hideNums(this.bankAcctNumber),
      ].toString();
      return currentAccount !== paymentData;
    },
    hadNSF() {
      return this.policyData?.payNowLinkDesc?.indexOf('unable to process') >= 0;
    },
    country() {
      return this.isCanadaPolicy ? 'ca' : 'us';
    },
    kubraLink() {
      const country: string = `${this.country}`;
      return window.appConfig.payments[country].kubraLink;
    },
  },
  watch: {
    routingNumber() {
      this.checkRouting();
    },
  },
  methods: {
    setPaymentMethod(method: number) {
      if (method === 2 && this.selectedAmountOverLimit) {
        // Skip the emit
      } else {
        this.routingNumber = '';
        this.bankAcctNumber = '';
        this.verifyBankAcctNumber = '';
        if (this.bankNameResponse && this.bankNameResponse.length > 0) {
          this.bankNameResponse = '';
        }
        // this.$v.bankAcctNumber.$dirty = false;
        // this.$v.verifyBankAcctNumber.$dirty = false;
        // this.$v.routingNumber.$dirty = false;
        this.paymentMethod = method;
        this.$emit('paymentMethodSet', method);
      }
    },
    async goToNextStep() {
      this.dialog = false;
      this.resetData();
      const win1 = await this.openInNewWindow({ url: this.kubraLink, target: 'KubraWinName' });
      this.$emit('goToStepThreeCC', win1);
    },
    resetData() {
      this.bankAcctNumber = '';
      this.verifyBankAcctNumber = '';
      this.routingNumber = '';
      this.accountHolderErrorMessages = [];
      this.showcheck = false;
      this.paymentMethod = -1;
    },
    validateAccountHolder() {
      let error1 = '';
      const tempAccountHolder = this.accountHolder;
      const regex = /^[a-zA-Z]+[\sa-zA-Z-.]{0,}[a-zA-Z]+$/;
      this.accountHolderErrorMessages = [];
      if (tempAccountHolder.trim().length === 0) {
        error1 = this.$t('L_account_holder_name_is_required');
      } else if (!regex.test(tempAccountHolder)) {
        error1 = this.$t('L_account_holder_name_is_invalid');
      }
      if (error1.length > 0) {
        this.accountHolderErrorMessages.push(error1);
      }
    },
    checkRouting() {
      if (this.v$.routingNumber.$invalid) {
        this.clearBank();
        return;
      }
      const country = this.isCanadaPolicy ? 'CA' : 'US';
      const payload = {
        policyNo: this.policyData?.contractId,
        routingNumber: this.routingNumber,
        country,
      };
      this.getBankInfo(payload);
    },
    getBankInfo(payload: IGetBankDataPayload) {
      return this.policyStore
        .getBankInfo(payload)
        .then((response: boolean) => {
          if (!response) {
            this.clearBank();
          }
          return response;
        })
        .catch((error: unknown) => {
          this.clearBank();
          throw error;
        });
    },
    goToStepThree() {
      // * Dynatrace Tag (https://primerica.atlassian.net/wiki/spaces/PD/pages/19955873/Payments+-+Custom+Dynatrace+Tags)
      try {
        const method = this.paymentMethod === 2 ? 'Credit/Debit' : 'ACH';
        const i = this.$dynatrace.enterAction(`PaymentMethod_Selected: ${method})`);
        this.$dynatrace.leaveAction(i);
      } catch (_error) {
        /* empty */
      }

      if (this.paymentMethod === 2) {
        // Credit Debit Card
        // * Dynatrace Tag (https://primerica.atlassian.net/wiki/spaces/PD/pages/19955873/Payments+-+Custom+Dynatrace+Tags)
        try {
          const i = this.$dynatrace.enterAction(
            'OneTimePayment_CreditCard_YoureLeavingMyPrimerica_PageDisplayed'
          );
          this.$dynatrace.leaveAction(i);
        } catch (_error) {
          /* empty */
        }
        this.dialog = true;
      } else {
        // Checking and Savings
        const paymentData = {
          amount: this.selectedAmount, // this.policyData?.paymentInfo?.PACPremium,
          // Edit allowed as of MYP-2480
          accountHolder: this.accountHolder, // this.policyData?.owner?.name,
          accountNumber: this.bankAcctNumber,
          accountType: '',
          accountCode: '',
          bankName: this.bankName,
          paymentType: this.$t(this.formattedPaymentType),
          routingNumber: this.routingNumber,
          differentAccount: this.accountDiff,
          hadNSF: this.hadNSF,
        };
        if (this.paymentMethod === 0) {
          // Checking
          paymentData.accountType = this.$t(this.checkingAccount);
          paymentData.accountCode = '0';
        } else if (this.paymentMethod === 1) {
          // Savings
          paymentData.accountType = this.$t('L_savings_account');
          paymentData.accountCode = '1';
        }

        this.policyStore.paymentData = paymentData;
        this.$emit('goToStepThree');
        this.policyStore.preLoadBank = this.accountDiff;
      }
      this.resetData();
    },
    clearBank() {
      this.policyStore.bankName = null;
    },
    cancel() {
      // * Dynatrace Tag (https://primerica.atlassian.net/wiki/spaces/PD/pages/19955873/Payments+-+Custom+Dynatrace+Tags)
      try {
        const i = this.$dynatrace.enterAction('PC2_PolicyMethod_Cancel');
        this.$dynatrace.leaveAction(i);
      } catch (_error) {
        /* empty */
      }
      this.$emit('cancelDialog');
    },
    hideNums(val: string) {
      return filters.methods.hideNumbers(val);
    },
    showCheckImage() {
      this.showcheck = true;
    },
    copyPolicyToClipboard() {
      void navigator.clipboard.writeText(this.contractId);
    },
  },
  mounted() {
    this.accountHolder = this.policyData?.owner?.name;
  },
  validations() {
    return {
      paymentMethod: {
        required,
      },
      bankName: {
        required,
      },
      bankAcctNumber: {
        required,
        notSameDigits,
        minLength: minLength(6),
        maxLength: maxLength(this.isCanadaPolicy ? 12 : 17),
      },
      routingNumber: {
        required,
        notSameDigits,
        minLength: minLength(this.isCanadaPolicy ? 8 : 9),
      },
      verifyBankAcctNumber: {
        required,
        notSameDigits,
        sameAs: sameAs(this.bankAcctNumber),
      },
    };
  },
};

export default defineComponent(componentOptions);
</script>

<style>
.bg-light-grey {
  background-color: #f5f5f5;
}
.blueBox {
  padding: 16px 24px 24px 24px;
  border-top: 8px solid #3399ff;
  border-left: 2px solid #3399ff;
  border-right: 2px solid #3399ff;
  border-bottom: 2px solid #3399ff;
  background-color: #e2f0fe;
}
.gray-border-box {
  border: 2px solid #e3e3e3;
  padding-top: 10px;
  padding-bottom: 10px;
  background-color: #ffffff;
}
.green-border-box {
  border: 2px solid #39ac4b;
  padding-top: 10px;
  padding-bottom: 10px;
  background-color: #d8f8dd;
}
.greenCheckRight {
  float: right;
  margin-right: 5px;
}
.ml10 {
  margin-left: 10px;
}
.blueText {
  color: #0c6dca;
}
.LRBottom {
  border-left: 2px solid black;
  border-bottom: 2px solid black;
  border-right: 2px solid black;
}
.bottomBorder {
  border-bottom: 2px solid black;
}
.emptyLine {
  height: 50px;
}
.emptyLine2 {
  height: 30px;
}
.checkCSS {
  padding-left: 50px;
  padding-right: 50px;
  background-image: url(./check-mobile.svg);
  height: 136px;
}
.checkBlueText {
  color: #385d81;
}
.pLpR50 {
  padding-left: 50px;
  padding-right: 50px;
}
.spaceBelow10 {
  margin-bottom: 10px;
}
.spaceToRight {
  margin-right: 15px !important;
}
.maxwidthButton {
  max-width: 300px;
}
.maxwidthButton2 {
  max-width: 295px;
  width: 295px;
  font-size: 16px;
}
.centerText {
  margin: auto;
}
#bank_name {
  color: #000000 !important;
}
label.v-label.v-label--active.v-label--is-disabled.theme--light {
  color: #000000 !important;
}
.mouseCursor {
  cursor: pointer;
}
.blackText {
  color: #000000 !important;
}
.centerButton {
  margin: auto;
}
.labelBankName {
  color: rgba(0, 0, 0, 0.54);
  font-size: 12px;
}
.valueBankName {
  font-size: 16px;
  height: 24px;
  margin-bottom: 64px;
}
.clickable {
  cursor: pointer;
}
.blue_label {
  color: #02579e;
}
.gray-box {
  background-color: darkgray !important;
  cursor: default !important;
}
.legend-text {
  width: 33.3%;
}
</style>
